import { render } from "./navigationbutton.vue?vue&type=template&id=7422951c"
import script from "./navigationbutton.vue?vue&type=script&lang=js"
export * from "./navigationbutton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__